<div class="save-container min-h-12">
    @if (!showLoader && !success) {
        <app-cta-button
            class="w-full"
            type="button"
            [variant]="variant()"
            [additionalClasses]="computedClasses()"
            [disabled]="disabled || isImpersonating()"
            [attr.data-testid]="testId"
            (onClick)="onClick.emit($event)">
            <ng-content></ng-content>
        </app-cta-button>
    }

    @if (showLoader && !success) {
        <app-loader color="#EE5769"></app-loader>
    }
    @if (!showLoader && success) {
        <app-checkmark class="mx-auto block" [animated]="true"></app-checkmark>
    }
</div>
